import { render, staticRenderFns } from "./PromoEnd.vue?vue&type=template&id=6f7c1285&scoped=true&"
import script from "./PromoEnd.vue?vue&type=script&lang=js&"
export * from "./PromoEnd.vue?vue&type=script&lang=js&"
import style0 from "./PromoEnd.vue?vue&type=style&index=0&id=6f7c1285&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7c1285",
  null
  
)

export default component.exports